// REACT IMPORTS
import React, { useState } from "react";

// REACT IMPORTS
import { Link } from "react-router-dom";

// STYLES
import "../styles/Terms.css";

// COMPONENTS
import { ContactForm } from "../components/ContactForm";

export const Terms = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const logoUrl: string = "brand_marks/Augio_FullType_Logo_latest.png";

  return (
    <main className="terms-container">
      <Link className="terms-augio" to="/">
        AUGIO
      </Link>

      <div className="inner-text">
        <h1 className="terms-header">Augio Terms of Use</h1>
        <h3 className="terms-subheader">Effective Date: June 9, 2026</h3>

        <h2 className="terms-subheader">1. Acceptance of Terms</h2>
        <div className="terms-subtext">
          These Terms of Use govern your access to and use of Augio, including
          our mobile applications, website, and related services (collectively,
          the "Service").
        </div>
        <div className="terms-subtext">
          By accessing or using the Service, you agree to be bound by these
          Terms and our Privacy Policy. If you do not agree to these Terms, you
          should not use the Service.
        </div>

        <h2 className="terms-subheader">2. About Augio</h2>
        <div className="terms-subtext">
          Augio is a music discovery platform focused on helping users discover
          independent music through location-based charts, regional feeds,
          trending releases, artist discovery tools, and related features.
        </div>
        <div className="terms-subtext">
          Augio does not host, stream, distribute, or sell music. The Service
          may provide links to third- party streaming platforms and websites
          where music and related content may be accessed.
        </div>
        <div className="terms-subtext">
          Charts, rankings, recommendations, and discovery features are
          generated via our curation team and by using activity and engagement
          data available to Augio and may change over time.
        </div>

        <h2 className="terms-subheader">3. Eligibility</h2>
        <div className="terms-subtext">
          The Service is intended for individuals who are at least 18 years of
          age.
        </div>
        <div className="terms-subtext">
          If you are under the age of majority in your jurisdiction, you should
          use the Service only with the involvement of a parent or legal
          guardian.
        </div>

        <h2 className="terms-subheader">4. Acceptable Use</h2>
        <div className="terms-subtext">
          You agree to use the Service only for lawful purposes and in
          accordance with these Terms.
        </div>
        <div className="terms-subtext">You may not:</div>
        <ul>
          <li className="terms-subtext">
            Violate any applicable law or regulation.
          </li>
          <li className="terms-subtext">
            Attempt to gain unauthorized access to the Service or its systems.
          </li>
          <li className="terms-subtext">
            Interfere with or disrupt the operation of the Service.
          </li>
          <li className="terms-subtext">
            Use bots, scripts, automated tools, or artificial means to
            manipulate rankings, charts, engagement metrics, or platform
            activity.
          </li>
          <li className="terms-subtext">
            Copy, scrape, harvest, or reproduce substantial portions of the
            Service without written permission from Augio.
          </li>
          <li className="terms-subtext">
            Reverse engineer, modify, or attempt to derive source code from the
            Service.
          </li>
          <li className="terms-subtext">
            Use the Service in any manner that could damage, disable, or impair
            the platform.
          </li>
        </ul>

        <h2 className="terms-subheader">5. Platform Features</h2>
        <div className="terms-subtext">
          The Service may provide features that allow users to interact with
          content, create personal collections, save favorites, express
          preferences, participate in rankings, or engage with other
          discovery-related tools made available by Augio. These features are
          provided solely for personal use within the Service and do not grant
          any ownership rights in any music, recordings, artwork, trademarks, or
          other content displayed through the Service. Augio may add, remove,
          modify, or discontinue features at any time without notice.
        </div>

        <h2 className="terms-subheader">6. Third-Party Services</h2>
        <div className="terms-subtext">
          The Service may contain links to third-party websites, streaming
          services, ticketing providers, social media platforms, and other
          external services. These third-party services operate independently
          from Augio and are governed by their own terms and privacy policies.
          Augio does not control and is not responsible for the content,
          availability, security, accuracy, or practices of any third-party
          service. Your use of third-party services is at your own risk.
        </div>

        <h2 className="terms-subheader">7. Intellectual Property</h2>
        <div className="terms-subtext">
          The Service, including its software, design, logos, trademarks,
          charts, rankings, graphics, text, and other original content, is owned
          by Augio or its licensors and is protected by applicable intellectual
          property laws. All music, recordings, artwork, artist names,
          trademarks, and related content displayed through the Service remain
          the property of their respective owners. Augio does not claim
          ownership of any third-party music or related content.
        </div>

        <h2 className="terms-subheader">
          8. Advertising and Sponsored Content
        </h2>
        <div className="terms-subtext">
          The Service may display advertisements, sponsored placements, promoted
          content, or other commercial content. The appearance of such content
          does not constitute an endorsement by Augio of any product, service,
          artist, company, or organization.
        </div>

        <h2 className="terms-subheader">9. Service Availability</h2>
        <div className="terms-subtext">
          Augio may modify, suspend, discontinue, or update any portion of the
          Service at any time and without prior notice. We do not guarantee that
          the Service will always be available, uninterrupted, secure, or
          error-free.
        </div>

        <h2 className="terms-subheader">10. Disclaimer of Warranties</h2>
        <div className="terms-subtext">
          THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. TO THE
          MAXIMUM EXTENT PERMITTED BY LAW, AUGIO DISCLAIMS ALL WARRANTIES,
          EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS
          FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, ACCURACY, AND RELIABILITY.
        </div>

        <h2 className="terms-subheader">11. Limitation of Liability</h2>
        <div className="terms-subtext">
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, AUGIO, ITS AFFILIATES,
          OFFICERS, EMPLOYEES, AND AGENTS SHALL NOT BE LIABLE FOR ANY INDIRECT,
          INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES
          ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE. YOUR USE OF THE
          SERVICE IS AT YOUR OWN RISK. NOTHING IN THESE TERMS SHALL LIMIT OR
          EXCLUDE LIABILITY THAT CANNOT BE LIMITED OR EXCLUDED UNDER APPLICABLE
          LAW.
        </div>

        <h2 className="terms-subheader">12. Indemnification</h2>
        <div className="terms-subtext">
          You agree to indemnify and hold harmless Augio, its affiliates,
          officers, employees, and agents from any claims, damages, losses,
          liabilities, costs, and expenses arising from your violation of these
          Terms or misuse of the Service.
        </div>

        <h2 className="terms-subheader">13. Changes to These Terms</h2>
        <div className="terms-subtext">
          We may update these Terms from time to time. Updated Terms will be
          posted with a revised Effective Date. Your continued use of the
          Service after updated Terms become effective constitutes your
          acceptance of the revised Terms.
        </div>

        <h2 className="terms-subheader">14. Governing Law</h2>
        <div className="terms-subtext">
          These Terms shall be governed by and construed in accordance with the
          laws of the State of Michigan, without regard to conflict of law
          principles.
        </div>

        <h2 className="terms-subheader">15. Contact Information</h2>
        <div className="terms-subtext">
          If you have any questions regarding these Terms, please contact us{" "}
          <button
            onClick={() => setIsContactModalOpen(true)}
            style={{
              background: "none",
              border: "none",
              color: "inherit",
              textDecoration: "underline",
              cursor: "pointer",
              padding: 0,
              font: "inherit",
            }}
          >
            HERE
          </button>
        </div>

        <div className="terms-subtext">© AUGIO 2026 All Rights Reserved</div>
      </div>
      <ContactForm
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </main>
  );
};
